import { RoundButton } from '@/components/buttons/Buttons';
import { Checkbox, type CheckboxChangeEvent } from 'primereact/checkbox';
import type { DialogProps } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { MdPeople } from 'react-icons/md';
import SecondaryModal from './SecondaryModal';
import './travel-customization.styles.css';

interface ModalProps extends DialogProps {
	setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

const AddPeopleModal = (props: ModalProps) => {
	const { setVisible, ...rest } = props;
	const [selectedGroups, setSelectedGroups] = useState<Group[]>([]);

	const headerContent = (
		<div className="flex">
			<span className={'tc-modal-header-title'}>People</span>
		</div>
	);

	const footerContent = (
		<div>
			<RoundButton
				label="Save"
				onClick={() => setVisible(false)}
				id="save-people-group"
			/>
		</div>
	);

	const groups: Group[] = [
		{
			name: 'General',
			description: 'Design, BAs, and QAs',
			peopleCount: 20,
		},
		{
			name: 'Product Team',
			description: 'Design, BAs, and QAs',
			peopleCount: 5,
		},
	];

	const handleChange = (e: CheckboxChangeEvent) => {
		let _selectedGroups = [...selectedGroups];

		const selectedGroup = groups.find(
			(group) => group.name === e.value.name,
		);

		if (e.checked && selectedGroup) {
			_selectedGroups.push(selectedGroup);
		} else {
			_selectedGroups = _selectedGroups.filter(
				(group) => group.name !== e.value.name,
			);
		}

		setSelectedGroups(_selectedGroups);
	};

	return (
		<SecondaryModal
			{...rest}
			draggable={false}
			header={headerContent}
			footer={footerContent}
			style={{ width: '40rem' }}
		>
			{groups.map((group) => (
				<div
					key={group.name}
					className="flex w-full items-center justify-between py-3 px-4 border-b first:border-t border-neutralVariant90 cursor-pointer"
				>
					<div className="flex gap-2 w-1/2">
						<div className="mr-4">
							<MdPeople size={24} className="text-primary" />
						</div>
						<span className="text-body-medium text-base text-left text-neutral17">
							{group.name}
						</span>
					</div>

					<div className="w-1/2 text-left">
						<p className="text-neutral60 text-base text-body-medium">
							{group.peopleCount} People
						</p>
					</div>

					<div className="flex items-center">
						<Checkbox
							value={group}
							onChange={handleChange}
							checked={selectedGroups.some(
								(item) => item.name === group.name,
							)}
							pt={{
								root: {
									className: 'hover:bg-transparent',
								},
								box: {
									className: classNames('tc-checkbox-input', {
										'tc-checkbox-input-checked':
											selectedGroups.some(
												(item) =>
													item.name === group.name,
											),
									}),
								},
								icon: {
									className: classNames('tc-checkbox-icon'),
								},
							}}
						/>
					</div>
				</div>
			))}
		</SecondaryModal>
	);
};

export default AddPeopleModal;
